import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-noteblank",
  "use": "icon-th-noteblank-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-noteblank\">\n<path d=\"M26 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H19.5863C19.849 28.0008 20.1093 27.9494 20.352 27.8488C20.5947 27.7482 20.815 27.6003 21 27.4137L27.4137 21C27.6003 20.815 27.7482 20.5947 27.8488 20.352C27.9494 20.1093 28.0008 19.849 28 19.5863V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4ZM6 6H26V19H20C19.7348 19 19.4804 19.1054 19.2929 19.2929C19.1054 19.4804 19 19.7348 19 20V26H6V6ZM24.5863 21L21 24.5863V21H24.5863Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-noteblank.svg
// module id = u4Be
// module chunks = 84